(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("FormRequest", [
            'jquery'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.jquery
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($) {


    /**
     * Form request
     *
     * Call just on form or buttons
     *
     * @param element
     * @param options
     * @constructor
     */
    function Request (element, options) {

        this.element = element;
        this.$element = $(element);

        this.defaultOptions = {
            success: function () {},
            simple: function () {},
            error: function () {},
            beforeSend: function () {},
            complete: function() {},
            onEvent: function () {},
            ajaxSend: function () {},
            requestOptions: {
                method: this.$element.attr('method'),
                url: this.$element.attr('action'),
                data: 'default'
            },
            formData: false
        };

        this.events = {
            ajaxSuccess: 'AjaxSuccess',
            ajaxComplete: 'AjaxComplete',
            ajaxError: 'AjaxError'
        };

        this.options = $.extend({}, this.defaultOptions, options);

        this.setRequestOptions();

        this.init();
    }

    /**
     * @type {{init: Request.init, request: Request.request}}
     */
    Request.prototype = {
        setRequestOptions: function () {
            let options = this.options.requestOptions;

            for ( let option in options ) {
                if ( typeof options[option] === "string" && options[option].indexOf('data') >= 0 ) {
                    let value = options[option].split(" ")[1];

                    options[option] = this.$element.data(value);
                }
            }
        },

        init: function () {
            let self = this;

            if ( this.element === null ) {
                this.request();
                return false;
            }

            switch ( this.$element.prop('tagName').toLowerCase() ) {
                case "form":

                    this.options.formData = true;

                    this.addEventListener('submit');
                    break;

                case "a":
                case "button":
                    this.addEventListener('click');
                    break;

                default:
                    console.error("Call on wrong element!");
                    break;
            }
        },

        setElement: function () {
            this.element = document.querySelector(this.options.selector);
            this.$element = $(this.element);
        },

        /**
         * Add event listener
         *
         * @param event
         */
        addEventListener: function (event) {
            let self = this;

            this.currentEvent = event;

            $(document).on(event, this.options.selector, function (e) {
                e.preventDefault();

                self.options.onEvent.call(self.$element, e, self);

                self.setElement();
                self.request();
            });
        },

        /**
         * Remove event listener
         */
        removeEventListener: function () {
            $(document).off(this.currentEvent, this.options.selector);
        },

        setRequestData: function (data) {
            this.options.formData = false;
            this.options.requestOptions.data = data;
        },

        request: function () {
            let self = this,
                sortedArgs;

            if ( this.options.formData ) {
                this.options.requestOptions.data = this.$element.serialize();
            }

            $.ajax({
                'method': self.options.requestOptions.method || 'GET',
                'url': self.options.requestOptions.url,
                'data': self.options.requestOptions.data,
                'dataType': self.options.requestOptions.dataType || 'json',
                'beforeSend': function (jqxhr, settings) {
                    return self.options.beforeSend.call(self.$element, jqxhr, settings);
                },
                'statusCode': {
                    200: function (data) {
                        sortedArgs = self.getXHRArguments.apply(this, arguments);

                        $(document).trigger(self.events.ajaxComplete);
                        $(document).trigger(self.events.ajaxSuccess);

                        self.options.success.call(self.$element, sortedArgs, self);
                    },

                    201: function () {
                        sortedArgs = self.getXHRArguments.apply(this, arguments);

                        $(document).trigger(self.events.ajaxComplete);

                        self.options.simple.call(self.$element, sortedArgs, self);

                        self.options.complete.call(self.$element, sortedArgs, self);
                    },

                    400: function () {
                        sortedArgs = self.getXHRArguments.apply(this, arguments);

                        $(document).trigger(self.events.ajaxComplete);
                        $(document).trigger(self.events.ajaxError);

                        self.options.error.call(self.$element, sortedArgs, self);

                        self.options.complete.call(self.$element, sortedArgs, self);
                    }
                }
            });
        },

        getXHRArguments: function (ajaxData1, ajaxData2, ajaxData3) {
            //200-data, textStatus, jqXHR
            //400-jqXHR, textStatus, errorThrown
            let data, textStatus, jqXHR;

            if (ajaxData3.hasOwnProperty('statusCode')) {
                // 200
                data = ajaxData1;
                textStatus = ajaxData2;
                jqXHR = ajaxData3;
            } else if (ajaxData1.hasOwnProperty('statusCode')) {
                // error
                data = ajaxData1.responseJSON || ajaxData1.responseText;
                textStatus = ajaxData2;
                jqXHR = ajaxData1;
            }

            return {
                'data': data,
                'textStatus': textStatus,
                'jqXHR': jqXHR
            };
        }
    };

    $.fn.w5request = function (options) {
        return this.each(function () {
            new Request(this, options);
        });
    };

    return Request;

}));



//////////////////
// WEBPACK FOOTER
// ./js/modules/request/index.js
// module id = 1
// module chunks = 0 1 2 3 4